import { useLocation, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { DropdownMenu } from '../../../cdl/DropdownMenu/DropdownMenu';
import { translate } from '../../../common/helpers/translate.helper';
import { DeleteDraftConfirmPopup } from '../../common/DeleteDraftConfirmPopup';
import { OrderModel } from '../../model/OrderModel';

interface DraftActionsDropdwonMenuProps {
    order: OrderModel;
    onMarkRead: (order: OrderModel) => void;
    onDeleteConfirm: (orderId: string, options: { onSuccess: () => void }) => void;
    isDeleting?: boolean;
}

export const DraftActionsDropdownMenu = ({
    order,
    onMarkRead,
    onDeleteConfirm,
    isDeleting = false,
}: DraftActionsDropdwonMenuProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);

    const handleOnDeleteConfirm = (order: OrderModel) => {
        onDeleteConfirm(order.id, { onSuccess: () => setShowDeleteConfirmPopup(false) });
    };

    const handleDeleteClick = (event: Event) => {
        setShowDeleteConfirmPopup(true);
        event.stopPropagation();
    };

    const onDuplicateOrderClick = (e: Event) => {
        e.stopPropagation();

        void navigate({ to: '/orders/new', state: { order, originLocation: location } });
    };

    const options = [
        {
            label: order.read ? translate('actionListLabel.markAsUnread') : translate('actionListLabel.markAsRead'),
            onSelect: () => onMarkRead(order),
        },
        {
            label: translate('actionListLabel.copyDraftTo'),
            onSelect: onDuplicateOrderClick,
        },
        {
            label: translate('actionListLabel.delete'),
            onSelect: handleDeleteClick,
            destructive: true,
        },
    ];

    return (
        <>
            <DropdownMenu options={options} align="end" />
            <DeleteDraftConfirmPopup
                onSubmit={() => handleOnDeleteConfirm(order)}
                reference={order.buyerReference}
                isOpen={showDeleteConfirmPopup}
                onDismiss={() => setShowDeleteConfirmPopup(false)}
                isSubmitting={isDeleting}
            />
        </>
    );
};
